export const DefaultFastlyQueryScope = "fastly-cache";
export const DefaultQueryScope = "useQuery";
